export default "__VITE_ASSET__C5K6fImH__"